module.exports = __webpack_public_path__ + "assets/img/gd1.61369c24.jpg";